import { render, staticRenderFns } from "./FileImportLicensingDocuments.vue?vue&type=template&id=36e1e45e&"
import script from "./FileImportLicensingDocuments.vue?vue&type=script&lang=js&"
export * from "./FileImportLicensingDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports